import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, signal } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { Globals } from '../../shared/models/globals';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { PermissionsService } from '../../auth/auth-guard.guard';
import { MaterialModule } from '../../material/material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppColorsService } from '../../shared/services/app-colors.service';


@Component({
    selector: 'scout-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    providers: [UserService, PermissionsService],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, MaterialModule, TranslateModule, RouterModule]
})
export class SignInComponent implements OnInit {
  isLoginError = signal(false);
  isLoggingIn = signal(false);
  constructor(public userService : UserService,
    private translate: TranslateService,
    private appColorsService: AppColorsService,
    public router : Router,
    public _globals: Globals) { }

  

  ngOnInit() {
    this._globals.titleBarText="Dalecarlia Scouting - Logon";
    this._globals.isLoggedIn = false;
    this._globals.toolbarBackgroundColor = "gray";
  }

  private getToolbarColor(data: any): string | null {
    const color = data.ToolbarColor
      ?? data.toolbarColor
      ?? data.OrganizationColor
      ?? data.organizationColor
      ?? data.OrgColor
      ?? data.orgColor
      ?? data.BrandColor
      ?? data.brandColor;

    return typeof color === 'string' && color.trim().length > 0 ? color.trim() : null;
  }

  private getOrganizationName(data: any): string | null {
    const orgName = data.OrganizationName
      ?? data.organizationName
      ?? data.OrgName
      ?? data.orgName
      ?? data.Organization
      ?? data.organization;

    return typeof orgName === 'string' && orgName.trim().length > 0 ? orgName.trim() : null;
  }

  OnSubmit(userName: string,password: string){
    this.isLoggingIn.set(true);
     this.userService.userAuthentication(userName,password).subscribe({
      next: (data: any) =>{
        localStorage.setItem('userToken',data.access_token);
        localStorage.setItem('userRoles',data.role);
        localStorage.setItem('Name',data.Name);
        localStorage.setItem('Modules', data.module);      
        localStorage.setItem("OrgLogo", data.OrganizationSmallImage);
        const organizationName = this.getOrganizationName(data);
        if (organizationName) {
          localStorage.setItem('OrganizationName', organizationName);
        }
        const activeTheme = localStorage.getItem('theme') ?? this._globals.theme;
        const appPrimaryColor = this.appColorsService.applyFromLoginResponse(data, activeTheme);
        this.appColorsService.applyStoredThemeColors(activeTheme);
        const toolbarColor = this.getToolbarColor(data) ?? appPrimaryColor;
        if (toolbarColor) {
          localStorage.setItem('ToolbarColor', toolbarColor);
          this._globals.toolbarBackgroundColor = toolbarColor;
        } else {
          localStorage.removeItem('ToolbarColor');
        } 
        //console.log("data.module");
        //console.log(data.module);
        localStorage.setItem('OrganizationId', data.OrganizationId);      
        localStorage.setItem('UserId', data.UserId);      
        
        localStorage.setItem('isLoggedIn','true');
        this._globals.UserFullName = data.Name;
        this._globals.organizationId = data.OrganizationId;
        this._globals.sendMessage("Logged in");
        this._globals.UserId = data.UserId;

        //console.log("OnSubmit-globals.isloggedin: " + this._globals.isLoggedIn );

        this.router.navigateByUrl('/games3');

      },
      error: (e: any) => { 

        this.isLoggingIn.set(false);
        this.isLoginError.set(true);
      },
      complete() { 
        // console.log('complete') 
      }


     
    });
  }

}
